//报名招生
module.exports = {
    zh: {  //中文
      admissionsManagement: {   //招生管理
        addTags:'添加标签',
        add:'添加',
        close:'关闭',
        channelName:'渠道名称',
        pickingNumber:'采单人数',
        numberOfVisitors:'入园人数',
        conversionRate:'转化率',
        addingChannels:'添加渠道',
        deliveryChannel:'投放渠道',
        phoneTime:'电话时间',
        visitingTime:'来访时间',
        interviewTime:'面试时间',
        babyBirthday:'宝宝生日',
        state:'状态',
        Label:'标签',
        date:'日期',
        time:'时间',
        garden:'园所',
        photo:'头像',
        topicTypes:'题目类型',
        title:'题目',
        ScheduleTour: '预约参观',
        Interview: '面谈',
        OfferSent: '已发送offer',
        OfferConfirm: '确认入园',
        OfferInvalidedz: '取消入园',
        babyName: '宝宝姓名',
        sex: '性别',
        englishNameOfBaby:'宝宝英文名',
        birthday: '生日',
        age: '年龄',
        export: '导出报名记录',
        weChatID: '微信号',
        relationship: '与宝宝关系',
        enrolment: '报名人',
        currentSchool: '在读学校',
        contactway: '联系方式',
        source: '来源',
        applicationTime: '申请日期',
        nextReservationTime: '下次预约时间',
        signUp: '添加报名',
        batchImportRegistration:'批量报名导入',
        search: '搜索',
        reset:'重置',
        No: '序号',
        operation: '操作',
        Dateofvisit: '来访日期',
        Dateofinterview: '面试日期',
        class: '班级',
        Plannedclass: '计划班级',
        PlannedDate: '计划入园日期',
        expectedEentryTime: '期望入园时间',
        Dateofadmission: '入园日期',
        Dateofregistration: '创建日期',
        Cancellationdate: '取消日期',
        FollowUupDate: '跟进日期',
        FollowUpRecords: '跟进记录',
        check:'查看',
        checkInformation:'查看报名信息',
        activation: '激活',
        Registrationinformation: '报名信息',
        Gender: '性别',
        Tel:'手机号码',
        address: '地址',
        resourceof: '信息获取途径',
        remarks: '备注',
        occupation: '职业',
        email: '邮箱',
        Visitfeedback: '来访反馈',
        visitTime: '参观时长(分钟)',
        Receptionist: '接待人',
        Visitingeffect: '参观效果',
        parentalInterviewTitle: '家长面试题目',
        familyInfo: '家庭信息',
        studentInterviewTitle: '学生面试题目',
        Essentialinformation: '基本信息',
        Chinesename:'中文姓名',
        Englishname: '英文姓名',
        Dateofbirth: '出生日期',
        Fathersname: '父亲姓名',
        Fathersprofession: '父亲职业',
        Fatherscellphone: '父亲手机号',
        Fathersemail: '父亲邮箱',
        Mothersname: '母亲姓名',
        Mothersprofession: '母亲职业',
        Motherscellphone: '母亲手机号',
        Mothersemail:'母亲邮箱',
        Interviewresults: '面试结果',
        Interviewer: '面试人',
        Personincharge: '负责人',
        Interviewquestions: '面试题目',
        question1: '1.请介绍您本人及家庭情况',
        question2: '2.孩子主要由谁照顾',
        question3: '3.全家人喜欢一起做什么',
        question4: '4.请用三个词组描述孩子性格特点，及在集体活动与同伴互动情况。',
        question5: '5.幼儿园作为小的集体社会，孩子们子啊奔跑或与其他人互动中难免有磕磕碰碰，以下有三种情况，您如何看待？您的孩子自己磕伤了；您的孩子打了别的孩子；您的孩子被别的小朋友打了',
        question6: '6.请陈述您的孩子的优点。',
        question7: '7.您的孩子感到最有趣或最能激励TA的是什么？',
        question8: '8.您的孩子有什么困难需要我们帮TA克服吗？比如独立技能，生存特殊需求，社交技能，特殊学习',
        question9: '9.当孩子表现不好时，您在家时如何管教TA？',
        question10: '10.您家里的每个人能支持孩子理解这种教育的过程吗？',
        question11: '11.为什么考虑离园?(选择性提问)',
        question12: '12.为了方便家长了解孩子的实时状态，KRK为家长开放了全天监控，对此您怎么看？(如别的小朋友在上课，自己的孩子却乱跑；别的小朋友在吃加餐，而他没有等)',
        question13: '13.您希望孩子从我们幼儿园毕业时达到什么样的发展目标？',
        question14: '其他记录和评论',
        Entrancetime: '入园时间',
        Nextvisittime: '下次来访时间',
        Appointmenttime: '预约来访时间',
        FollowTime: '跟进时间',
        nextFollowTime: '下次跟进时间',
        studentDetailsEntry: '学生详情录入',
        Release: '发布',
        Return: '返回',
        Assignmentplanclass: '分配计划班级',
        edit:'编辑',
        delete:'删除',
        Preservation: '保存',
        cancel: '取消',
        Takeup: '收起',
        Open: '展开',
        confirm: '确定',
        Dateofreservation: '预约日期',
        Timeofappointment: '预约时间',
        echartsTitle: '班级-学生分班情况',
        number:'序号',
        arrangeClass:"计划班级",
        arrangeTime:"计划入园时间",
        addStudent:"添加学生",
        addTitle:"添加题目",
        other:"其他",
        addForm: '新建报名表',
        uploadForm: '修改报名表',
        formName: '报名表名称',
        createDate: '创建时间',
        copy: '复制二维码/链接',
        uploadCode: '下载二维码',
        copyLink: '复制链接',
        createCode: '生成二维码',
        putOnChannel: '投放渠道',
        content: '内容',
        formItem: '表单项',
        signUpForm: '报名表',
        appearance: '外观',
        required: '必填',
        sorting: '排序',
        remove: '移除',
        upload: '下载'
      }
    },
    en: {  //英文
      admissionsManagement: {   //招生管理
        addTags:'Add tags',
        add:'add',
        close:'close',
        channelName:'Channel Name',
        pickingNumber:'Picking Number',
        numberOfVisitors:'Number Of Visitors',
        conversionRate:'Conversion Rate',
        addingChannels:'Add Channels',
        deliveryChannel:'Delivery Channel',
        phoneTime:'Phone Time',
        visitingTime:'Visiting Time',
        interviewTime:'Interview Time',
        babyBirthday:'Baby Birthday',
        state:'State',
        Label:'Label',
        date:'Date',
        time:'Time',
        garden:'Garden',
        photo:'Head portrait',
        topicTypes:'Topic Types',
        title:'Title',
        ScheduleTour: 'Schedule Tour',
        Interview: 'Interview',
        OfferSent: 'Offer Sent',
        OfferConfirm: 'Offer Confirm',
        OfferInvalidedz: 'Offer Invalidedz',
        babyName: 'Child Name',
        sex: 'sex',
        englishNameOfBaby:'English Name of Baby',
        birthday: 'DOB',
        age: 'age',
        export: 'Export registration record',
        relationship: 'Relationship with baby',
        weChatID: 'WeChat ID',
        enrolment: 'enrolment',
        currentSchool:'Previous School',
        contactway: 'contact way',
        source: 'Resorce',
        applicationTime: 'application time',
        nextReservationTime: 'next reservation time',
        signUp: 'Add enrolment',
        batchImportRegistration:'batch import registration',
        search: 'search',
        reset:'reset',
        No: 'No',
        operation: 'operation',
        Dateofvisit: 'Date of visit',
        Dateofinterview: 'Date of interview',
        class: 'class',
        Plannedclass: 'Planned class',
        PlannedDate: 'Planned date',
        expectedEentryTime: 'Expected entry time',
        Dateofadmission: 'Date of admission',
        Dateofregistration: 'Creation date',
        Cancellationdate: 'Cancellation date',
        FollowUupDate: 'Follow up the date',
        FollowUpRecords: 'Follow up records',
        check:'check',
        checkInformation:'View registration information',
        activation: 'activation',
        Registrationinformation: 'Registration information',
        Gender: 'Gender',
        Tel:'Tel',
        address: 'Address',
        resourceof: 'Access to information',
        remarks: 'Note',
        occupation: 'Occupation',
        email: 'Email',
        Visitfeedback: 'Visit feedback',
        visitTime: 'Visit the long time',
        Receptionist: 'Receptionist',
        Visitingeffect: 'Visiting effect',
        parentalInterviewTitle: 'Parental interview title',
        familyInfo: 'Family information',
        studentInterviewTitle: 'Student interview title',
        Essentialinformation: 'Essential information',
        Chinesename:'Chinese name',
        Englishname: 'English name',
        Dateofbirth: 'Date of birth',
        Fathersname: "Father's name",
        Fathersprofession: "Father's profession",
        Fatherscellphone: "Father's cell phone",
        Fathersemail: "Father's cell email",
        Mothersname: "Mother's name",
        Mothersprofession: "Mother's profession",
        Motherscellphone: "Mother's cell phone",
        Mothersemail: "Mother's cell email",
        Interviewresults: 'Interview results',
        Interviewer: 'Interviewer',
        Personincharge: 'Person in charge',
        Interviewquestions: 'Interview questions',
        question1: '1.Please introduce yourself and your family',
        question2: '2.Who is the primary care for the child',
        question3: '3.What the family likes to do together',
        question4: "4.Please use three phrases to describe children's character and interaction with group activities.",
        question5: '5.Kindergarten as a small collective society, children run or interact with other people, it is inevitable that there are three situations. How do you think about it? Your child has hurt himself; your child has attacked other children; your child has been beat by other children.',
        question6: '6.Please state the advantages of your child.',
        question7: "7.What is your child's most interesting or inspiring TA?",
        question8: "8.What difficulties do your children need to overcome by TA? For example, independent skills, survival special needs, social skills, special learning.",
        question9: '9.When children behave badly, how do you manage TA when you are at home?',
        question10: "10.Does everyone in your family support children's understanding of this educational process?",
        question11: '11.Why do you think about leaving the garden? (selective questions)',
        question12: "12.In order to facilitate parents to understand their children's real-time status, KRK has opened all day monitoring for their parents. What do you think of this? (for example, when other children are in class, their children are running away; other children are having meals while he is not waiting).",
        question13: '13.What kind of development goals do you want your children to graduate from our kindergarten?',
        question14: '14.Other records and comments',
        Entrancetime: 'Entrance time',
        Nextvisittime: 'Nextvisit time',
        Appointmenttime: 'Appointment time',
        FollowTime: 'Follow time',
        nextFollowTime: 'Next follow-up time',
        studentDetailsEntry: 'Student details entry',
        Release: 'Release',
        Return: 'Return',
        Assignmentplanclass: 'Assignment plan class',
        edit:'edit',
        Preservation: 'Preservation',
        cancel: 'cancel',
        Takeup: 'Take up',
        Open: 'Open',
        confirm: 'confirm',
        Dateofreservation: 'Date',
        Timeofappointment: 'Time',
        echartsTitle: 'Division of class students',
        number:'Number',
        arrangeClass:"arrangedClass",
        arrangeTime:"arrangedTime",
        addStudent:'addStudent',
        addTitle:"addTitle",
        other:"other",
        addForm: 'add form',
        uploadForm: 'upload form',
        formName: 'form name',
        createDate: 'Creation time',
        copy: 'copy code/link',
        delete: 'delete',
        uploadCode: 'upload code',
        copyLink: 'copy link',
        createCode: 'create code',
        putOnChannel: 'put on channel',
        content: 'content',
        formItem: 'form item',
        signUpForm: 'sign up form',
        appearance: 'appearance',
        required: 'mandatory',
        sorting: 'sorting',
        remove: 'remove',
        upload: 'upload'
      }
    }
  
  }


// WEBPACK FOOTER //
// ./src/components/i18n/lang/enrollAndRecruit.js